import {
    Cart
} from "@dana/Overrides/Services/CartService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, PopulateCart } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SaveShipping";
import { getCookie } from "@insite/mobius/utilities/cookies";
// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(
    chain,
    PopulateCart,
    props => {
        const state = props.getState() as ApplicationStateDana;
        const cartMode = getCookie('cartMode');
        const { cartId } = state.pages.onePageCheckout;
        let cart: Cart | undefined;
        if (cartMode === 'StockOrderCart') {
            cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value
        } else if (cartMode === 'EmergencyOrderCart') {
            cart = state.emergencyCartState.cart as Cart;
        } else {
            cart = state.annualReturnsCartState.cart as Cart;
        }
        if (!cart) {
            throw new Error("There was no current cart available while trying to update the current cart.");
        }

        props.cart = { ...cart };
    }
);